import React from 'react';
import './SearchSuggestions.css';

const SearchSuggestions = () => {
  return (
    <div className="suggestions-wrapper">
      <ul className="suggestions-list">
        <li>Pasta</li>
        <li>Burger</li>
        <li>Pizza</li>
        <li>Sushi</li>
        <li>Salad</li>
        <li>Steak</li>
        <li>Tacos</li>
        <li>Ice Cream</li>
      </ul>
    </div>
  );
};

export default SearchSuggestions;
